<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 500"
    :fileAdd="checkData.images.length <= 12"
    :files="checkData.images"
    :delete-files="checkData.deleteFiles"
    maxFiles="1"
    maxFilesShow="1"
    :on-save="onSave"
  >
    <v-form class="d-grid gap-row-5" ref="form" lazy-validation>
      <BaseInput
        type="date-picker"
        :label="localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya']"
        v-model="checkData.cardDateEnd"
        :min="new Date().toISOString().slice(0, 10)"
        placeholder="–"
        :rules="checkData.images.length ? ['required'] : null"
        :view="!editing"
        :view-value="$formatDate(checkData.cardDateEnd)"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'SafetyCard',
  props: {
    editing: Boolean,
    safety_card: Object,
    userId: Number,
    onSave: Function,
    modal: Boolean,
  },
  components: {
    PersonalAreaTemplate,
  },
  data: () => ({
    cardData: null,
    checkData: {
      cardDateEnd: null,
      images: [],
      deleteFiles: [],
    },
  }),
  watch: {
    safety_card() {
      if (this.safety_card) {
        this.cardData = JSON.parse(this.safety_card.data)
      }
    },
    cardData() {
      this.checkData.cardDateEnd = this.cardData.date_end
      if (typeof this.cardData.image === 'string') {
        this.checkData.images = [this.cardData.image]
      } else {
        this.checkData.images = this.cardData.image || []
      }
      this.onNavigationGuardianCheck({
        data: { safetyCard: this.checkData },
        overwrite: true,
      })
    },
    'checkData.images'() {
      for (let i in this.checkData.images) {
        if (this.checkData.images[i] === null || '' || undefined) {
          this.checkData.images.splice(i, 1)
        }
      }
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { safetyCard: this.checkData },
            overwrite: false,
          })
        }
      },
    },
  },
  computed: {},
  mounted() {
    if (this.safety_card && !this.cardData) {
      this.cardData = JSON.parse(this.safety_card.data)
    }
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    async deleteImageBD() {
      if (this.checkData.deleteFiles.length) {
        for (let i in this.checkData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.checkData.deleteFiles[i],
          })
        }
      }
    },
    async submitFile(type) {
      if (this.checkData.images && this.checkData.images.length) {
        for (let imgKey in this.checkData.images) {
          const item = this.checkData.images[imgKey]
          if (typeof item !== 'string') {
            let formData = new FormData()
            formData.append('file', item)
            await this.$store
              .dispatch('uploadFile', {
                data: formData,
                use_case: item.type === 'application/pdf' ? null : 'cover',
              })
              .then((response) => {
                this.checkData.images[imgKey] = response.data.url
              })
              .catch()
          }
        }
      }
    },
    saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('safetyCard')) {
          await this.submitFile().then(() => {
            let data = {
              type: 'safety_card',
              data: JSON.stringify({
                date_end: this.checkData.cardDateEnd,
                image: this.checkData.images,
              }),
            }
            if (this.safety_card && this.safety_card.data) {
              data.id = this.safety_card.id
            } else {
              if (this.$route.name === 'PersonalAreaEmployeeEdit') {
                data.user_id = this.userId
              }
            }
            this.onNavigationGuardianCheck({
              data: { safetyCard: this.checkData },
              overwrite: true,
            })
            resolve(data)
          })
          await this.deleteImageBD()
        } else resolve(true)
      })
    },
  },
}
</script>
